import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const shareSaveVarientSlice = createApi(`ShareSaveVarientSlice`,"POST");

const ShareSaveVarientSlice = createSlice({
  name: 'ShareSaveVarientSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(shareSaveVarientSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(shareSaveVarientSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(shareSaveVarientSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ShareSaveVarientSlice.reducer;
